import { useEffect, useRef } from "react";
export var useIsMounted = function () {
    var isMountedRef = useRef(true);
    var isMounted = function () { return isMountedRef.current; };
    // reset for react 18 dev mode running useEffect twice
    useEffect(function () {
        isMountedRef.current = true;
        return function () { return void (isMountedRef.current = false); };
    }, []);
    return isMounted;
};
